import { c as _c } from "react/compiler-runtime";
import { LegalDisclaimer } from "@components/FormConsent";
import LeadWallForm, { LeadWallFormValue } from "@components/LeadWall/LeadWallForm";
import TinyPropertyCard from "@components/TinyPropertyCard";
import { logger } from "@justhome/common";
import { LeadCreationResponse, MeetingLead, PostMeetingLeadQueryParams, usePostMeetingLead } from "@justhome/api-core";
import { ClientMode, PartnerCRMProperty } from "@justhome/api-core";
import { Button, getFormConsentText, Icon, IconType, Title } from "@justhome/react-ui";
import useLanguage from "@lib/hooks/useLanguage";
import usePartnerContext from "@lib/hooks/usePartnerContext";
import { yes } from "@lib/options";
import { localeToLanguageISOCode } from "@lib/utilities";
import { getOrigin } from "@lib/utm";
import useBookingTranslation from "@modules/booking/lib/hooks/useBookingTranslation";
import clsx from "clsx";
import { Fragment } from "react";
import BookingCard from "../BookingCard";
import InfoCard from "../InfoCard";
import PropertyFields from "../PropertyForm/PropertyFields";
interface BookingLeadWallProps {
  onLeadCreated: (lead: LeadCreationResponse) => void;
  property?: PartnerCRMProperty;
  contactId?: string;
  emailFromQuery?: string;
  partnerId?: string;
  clientMode?: ClientMode;
}
const TrustBadges = t0 => {
  const $ = _c(14);
  const {
    title,
    description,
    stats
  } = t0;
  let t1;
  if ($[0] !== title) {
    t1 = <Title className="text-h1 font-semibold mb-s text-balance">{title}</Title>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== description) {
    t2 = description && <p className="text-body-2">{description}</p>;
    $[2] = description;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div className="flex flex-col mb-s">{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== stats) {
    t4 = stats.map(_temp);
    $[7] = stats;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t4) {
    t5 = <div className="flex flex-col gap-2xs">{t4}</div>;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t3 || $[12] !== t5) {
    t6 = <div>{t3}{t5}</div>;
    $[11] = t3;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
};
const BookingLeadWall = t0 => {
  const $ = _c(98);
  const {
    onLeadCreated,
    property,
    contactId,
    emailFromQuery,
    partnerId,
    clientMode
  } = t0;
  const {
    t
  } = useBookingTranslation();
  const locale = useLanguage();
  const {
    partner
  } = usePartnerContext();
  let t1;
  if ($[0] !== locale || $[1] !== partner) {
    t1 = getFormConsentText({
      locale,
      partner
    });
    $[0] = locale;
    $[1] = partner;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const consentText = t1;
  let t2;
  if ($[3] !== onLeadCreated) {
    t2 = {
      onSuccess(lead) {
        onLeadCreated(lead);
      },
      onError(error) {
        logger.error("Error while posting a lead.", error);
      }
    };
    $[3] = onLeadCreated;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const {
    mutate,
    isLoading,
    isError
  } = usePostMeetingLead(t2);
  let t3;
  if ($[5] !== clientMode || $[6] !== consentText || $[7] !== locale || $[8] !== mutate || $[9] !== partnerId || $[10] !== property?.id) {
    t3 = values => {
      const origin = getOrigin();
      const realEstateAgentFeePercentage = values.hasRealEstateAgentFee === yes && values.realEstateAgentFeePercentage ? Number(values.realEstateAgentFeePercentage.replace(",", ".")) : undefined;
      const body = {
        firstName: values.firstName,
        lastName: values.lastName,
        email: values.email,
        phone: values.phone,
        language: localeToLanguageISOCode(locale),
        propertyId: property?.id,
        origin,
        partnerId,
        consentText,
        purchasePrice: values.purchasePrice,
        postalCode: values.postalCode,
        realEstateAgentFeePercentage
      };
      const queryParams = {};
      if (clientMode) {
        queryParams.clientMode = clientMode;
      }
      mutate({
        body,
        queryParams
      });
    };
    $[5] = clientMode;
    $[6] = consentText;
    $[7] = locale;
    $[8] = mutate;
    $[9] = partnerId;
    $[10] = property?.id;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  const handleSubmitWithLeadWall = t3;
  let t4;
  if ($[12] !== clientMode || $[13] !== consentText || $[14] !== contactId || $[15] !== emailFromQuery || $[16] !== locale || $[17] !== mutate || $[18] !== partnerId || $[19] !== property?.id) {
    t4 = () => {
      const origin_0 = getOrigin();
      mutate({
        body: {
          contactId,
          origin: origin_0,
          partnerId,
          language: localeToLanguageISOCode(locale),
          ...(emailFromQuery ? {
            email: emailFromQuery
          } : {}),
          propertyId: property?.id,
          consentText
        },
        queryParams: {
          clientMode
        }
      });
    };
    $[12] = clientMode;
    $[13] = consentText;
    $[14] = contactId;
    $[15] = emailFromQuery;
    $[16] = locale;
    $[17] = mutate;
    $[18] = partnerId;
    $[19] = property?.id;
    $[20] = t4;
  } else {
    t4 = $[20];
  }
  const handleSubmitWithContactId = t4;
  const isPartnerContactId = !!(contactId && partnerId);
  let t5;
  if ($[21] !== partnerId || $[22] !== t) {
    t5 = partnerId ? t("leadWall.partnerDescription") : t("leadWall.description");
    $[21] = partnerId;
    $[22] = t;
    $[23] = t5;
  } else {
    t5 = $[23];
  }
  const description = t5;
  let t6;
  if ($[24] !== t) {
    t6 = t("leadWall.banksComparison");
    $[24] = t;
    $[25] = t6;
  } else {
    t6 = $[25];
  }
  let t7;
  if ($[26] !== t6) {
    t7 = {
      label: t6
    };
    $[26] = t6;
    $[27] = t7;
  } else {
    t7 = $[27];
  }
  let t8;
  if ($[28] !== t) {
    t8 = t("leadWall.digitalAndTransparent");
    $[28] = t;
    $[29] = t8;
  } else {
    t8 = $[29];
  }
  let t9;
  if ($[30] !== t8) {
    t9 = {
      label: t8
    };
    $[30] = t8;
    $[31] = t9;
  } else {
    t9 = $[31];
  }
  let t10;
  if ($[32] !== t) {
    t10 = t("leadWall.freeForBuyers");
    $[32] = t;
    $[33] = t10;
  } else {
    t10 = $[33];
  }
  let t11;
  if ($[34] !== t10) {
    t11 = {
      label: t10
    };
    $[34] = t10;
    $[35] = t11;
  } else {
    t11 = $[35];
  }
  let t12;
  if ($[36] !== t11 || $[37] !== t7 || $[38] !== t9) {
    t12 = [t7, t9, t11];
    $[36] = t11;
    $[37] = t7;
    $[38] = t9;
    $[39] = t12;
  } else {
    t12 = $[39];
  }
  const stats = t12;
  let t13;
  if ($[40] !== t) {
    t13 = t("leadWall.sslEncrypted");
    $[40] = t;
    $[41] = t13;
  } else {
    t13 = $[41];
  }
  let t14;
  if ($[42] !== t13) {
    t14 = {
      label: t13,
      icon: "Lock"
    };
    $[42] = t13;
    $[43] = t14;
  } else {
    t14 = $[43];
  }
  let t15;
  if ($[44] !== t) {
    t15 = t("leadWall.gdprCompliant");
    $[44] = t;
    $[45] = t15;
  } else {
    t15 = $[45];
  }
  let t16;
  if ($[46] !== t15) {
    t16 = {
      label: t15,
      icon: "Shield"
    };
    $[46] = t15;
    $[47] = t16;
  } else {
    t16 = $[47];
  }
  let t17;
  if ($[48] !== t) {
    t17 = t("leadWall.hundredPercentFree");
    $[48] = t;
    $[49] = t17;
  } else {
    t17 = $[49];
  }
  let t18;
  if ($[50] !== t17) {
    t18 = {
      label: t17,
      icon: "Check"
    };
    $[50] = t17;
    $[51] = t18;
  } else {
    t18 = $[51];
  }
  let t19;
  if ($[52] !== t14 || $[53] !== t16 || $[54] !== t18) {
    t19 = [t14, t16, t18];
    $[52] = t14;
    $[53] = t16;
    $[54] = t18;
    $[55] = t19;
  } else {
    t19 = $[55];
  }
  const footerItems = t19;
  let t20;
  if ($[56] !== description || $[57] !== isPartnerContactId || $[58] !== stats || $[59] !== t) {
    t20 = !isPartnerContactId && <div className="order-last m:order-first col-span-6 l:col-span-5 l:col-start-2 mt-m m:mt-none"><TrustBadges stats={stats} title={t("leadWall.title")} description={description} /></div>;
    $[56] = description;
    $[57] = isPartnerContactId;
    $[58] = stats;
    $[59] = t;
    $[60] = t20;
  } else {
    t20 = $[60];
  }
  const t21 = !isPartnerContactId;
  let t22;
  if ($[61] !== isPartnerContactId || $[62] !== t21) {
    t22 = clsx("col-span-6 flex flex-col mt-m m:mt-none", {
      "order-last m:order-first ": t21,
      "col-start-4": isPartnerContactId
    });
    $[61] = isPartnerContactId;
    $[62] = t21;
    $[63] = t22;
  } else {
    t22 = $[63];
  }
  let t23;
  if ($[64] !== property) {
    t23 = property && <TinyPropertyCard property={property} isLoading={false} className="mb-3s" />;
    $[64] = property;
    $[65] = t23;
  } else {
    t23 = $[65];
  }
  let t24;
  if ($[66] !== t) {
    t24 = t("leadWall.startConsultation");
    $[66] = t;
    $[67] = t24;
  } else {
    t24 = $[67];
  }
  let t25;
  if ($[68] !== t24) {
    t25 = <h2 className="text-h2 font-semibold mb-m text-balance">{t24}</h2>;
    $[68] = t24;
    $[69] = t25;
  } else {
    t25 = $[69];
  }
  let t26;
  if ($[70] !== description || $[71] !== isPartnerContactId || $[72] !== stats || $[73] !== t) {
    t26 = isPartnerContactId && <><p className="text-body-2 mb-3s">{description}</p><InfoCard title={t("leadWall.yourBenefits")} list={stats.map(_temp2)} className="mb-m" /></>;
    $[70] = description;
    $[71] = isPartnerContactId;
    $[72] = stats;
    $[73] = t;
    $[74] = t26;
  } else {
    t26 = $[74];
  }
  let t27;
  if ($[75] !== handleSubmitWithLeadWall || $[76] !== isError || $[77] !== isLoading || $[78] !== isPartnerContactId) {
    t27 = !isPartnerContactId && <LeadWallForm isError={isError} isLoading={isLoading} onSubmit={handleSubmitWithLeadWall} propertyFields={<PropertyFields />} />;
    $[75] = handleSubmitWithLeadWall;
    $[76] = isError;
    $[77] = isLoading;
    $[78] = isPartnerContactId;
    $[79] = t27;
  } else {
    t27 = $[79];
  }
  let t28;
  if ($[80] !== handleSubmitWithContactId || $[81] !== isLoading || $[82] !== isPartnerContactId || $[83] !== t) {
    t28 = isPartnerContactId && <><Button size="md" isLoading={isLoading} onClick={handleSubmitWithContactId} iconEnd="Right" fullWidth={true} className="mb-3s">{t("leadWall.submit")}</Button><LegalDisclaimer /></>;
    $[80] = handleSubmitWithContactId;
    $[81] = isLoading;
    $[82] = isPartnerContactId;
    $[83] = t;
    $[84] = t28;
  } else {
    t28 = $[84];
  }
  let t29;
  if ($[85] !== footerItems) {
    t29 = <ul className="flex items-end grow justify-around gap-2xs text-caption-1 m:text-app-body-1 text-neutral-675/60 border-t border-neutral-50 pt-3s mt-3s">{footerItems.map(_temp3)}</ul>;
    $[85] = footerItems;
    $[86] = t29;
  } else {
    t29 = $[86];
  }
  let t30;
  if ($[87] !== t22 || $[88] !== t23 || $[89] !== t25 || $[90] !== t26 || $[91] !== t27 || $[92] !== t28 || $[93] !== t29) {
    t30 = <BookingCard className={t22}>{t23}{t25}{t26}{t27}{t28}{t29}</BookingCard>;
    $[87] = t22;
    $[88] = t23;
    $[89] = t25;
    $[90] = t26;
    $[91] = t27;
    $[92] = t28;
    $[93] = t29;
    $[94] = t30;
  } else {
    t30 = $[94];
  }
  let t31;
  if ($[95] !== t20 || $[96] !== t30) {
    t31 = <div className="flex flex-col gap m:grid m:grid-cols-12 m:gap-l m:px-m m:items-center py-3s m:py-m">{t20}{t30}</div>;
    $[95] = t20;
    $[96] = t30;
    $[97] = t31;
  } else {
    t31 = $[97];
  }
  return t31;
};
export default BookingLeadWall;
function _temp(stat) {
  return <Fragment key={stat.label}><p className="font-medium flex items-center gap-2xs"><Icon type="CheckOne" className="text-primary-800 flex-none" size="24" />{stat.label}</p></Fragment>;
}
function _temp2(stat) {
  return stat.label;
}
function _temp3(item) {
  return <li key={item.label} className="flex items-center gap-2xs"><Icon type={item.icon as IconType} /> {item.label}</li>;
}